import {
  fetchAll,
  fetchFiltered,
  add,
  edit,
  show,
} from "@/api/frequency";

const state = {
  all: [],
  isLoading: false,
  frequencyById: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const frequencies = await fetchAll();
      commit("setAll", frequencies);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const frequency = await show(id);
      commit("setFrequencyById", frequency);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const frequencies = await fetchFiltered(queriesParams);
      commit("setAll", frequencies);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await edit(id, data);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async create({ dispatch, commit }, status) {
    commit("setLoading", true);
    try {
      await add(status);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },
};

const mutations = {
  setAll(state, frequency) {
    state.all = frequency;
  },

  setFrequencyById(state, frequency) {
    state.frequencyById = frequency;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.frequencyById = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
